import { render, staticRenderFns } from "./TeamForm.vue?vue&type=template&id=447de660&scoped=true"
import script from "./TeamForm.vue?vue&type=script&lang=js"
export * from "./TeamForm.vue?vue&type=script&lang=js"
import style0 from "./TeamForm.vue?vue&type=style&index=0&id=447de660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447de660",
  null
  
)

export default component.exports